export default "__VITE_ASSET__CyGvVkEK__"